import { t } from '@lingui/core/macro';
import { DateRangeFilter } from './DateFilter';
export const terminationDateFilterLabel = () => t({
    message: 'Termination date',
    comment: 'Insights: Termination date filter',
});
export function TerminationDateFilter() {
    return <DateRangeFilter name="metadataDocumentTerminationDate" label={terminationDateFilterLabel()}/>;
}
